<template>
    <div v-if="showModal" id="worker_list_modal" class="ui middle aligned center aligned grid">
        <div class="ui column segments">
            <div id="header" class="ui left aligned segment">
                <h3 class="ui header"> {{ center.name }} 직원</h3>
                <select class="ui simple dropdown" v-model="position">
                    <option :value="''">전체</option>
                    <option :value="'배송기사'">배송기사</option>
                    <option :value="'창고관리자'">창고관리자</option>
                    <option :value="'퇴사자'">퇴사자</option>
                </select>
            </div>
            <div id="body" class="ui segment">
                <table class="ui selectable very basic table">
                <thead>
                    <tr>
                        <th class="collapsing">#</th>
                        <th class="collapsing">이름</th>
                        <th class="collapsing">전화번호</th>
                        <th class="collapsing">직책</th>
                        <th class="collapsing">담당지역</th>
                        <th>설명</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(worker, index) in getWorkers()" :key="worker._id">
                        <td class="collapsing">{{ index+1 }}</td>
                        <td class="collapsing">{{ worker.name }}</td>
                        <td class="collapsing">{{ worker.phone }}</td>
                        <td class="collapsing">{{ worker.position }}</td>
                        <td class="collapsing">{{ (worker.regions) ? Object.keys(worker.regions).join(',') : "" }}</td>
                        <td>{{ worker.description }}</td>
                        <td class="right collapsing">
                            <div class="ui small icon buttons">
                                <button :class="worker == selected ? 'ui grey button' : 'ui basic button'" @click="editWorker(worker)">
                                    <i class="edit icon"></i>
                                </button>
                                <button class="ui basic button" @click="removeWorker(worker)">
                                    <i class="trash icon"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            </div>
            <div id="footer" class="ui right aligned segment">
                <div class="ui primary button" @click="addWorker()">추가</div>
                <div class="ui button" @click="close">닫기</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: function() {
        return { showModal: 0, center: 0, position: 0, onChange: 0, selected: 0, }
    },
    mounted: function() {
        this.$event.set("openWorkerList", this.open);
    },
    beforeDestroyed: function() {
        this.$event.clear("openWorkerList");
    },
    methods: {
        open(center, onChange) {
            this.showModal = true;
            this.center = center;
            this.position = "배송기사";
            this.onChange = onChange;
        },
        close() {
            this.showModal = false;
        },
        getWorkers() {
            const array = [];
            for (const worker of this.workers) {
                if (worker.position == this.position && worker._center == this.center._id) {
                    array.push(worker);
                }
            }
            return array;
        },
        addWorker() {
            this.$event.call("addWorker", this.center, this.onChange);
        },
        editWorker(worker) {
            this.selected = worker;
            this.$event.call("editWorker", this.center, worker, this.onChange);
        },
        removeWorker(worker) {
            this.$event.call("openPopup", worker.name + " 직원을 삭제하시겠습니까?", "", () => {
                this.$event.call("openLoading");
                this.$api.removeWorker(worker._id, (resData) => {
                    this.$event.call("closeLoading");
                    if (resData.error) {
                        alert(resData.error.message);
                    } else {
                        if (this.onChange) this.onChange();
                    }
                });
            });
        },
    },
    computed: {
        workers: {
            get: function() { return this.$store.getters.workers; },
            set: function(val) { this.$store.commit("setWorkers", val); },
        },
    },
}
</script>

<style>

#worker_list_modal {
    position: fixed;
    left: 0;
    top: 0;
    margin: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0,0,0,0.8);
}

#worker_list_modal .column {
    max-width: 900px;
}

#worker_list_modal #header {
    padding: 20px 30px;
}

#worker_list_modal #body {
    padding: 0;
}

#worker_list_modal #body .table {
    padding: 30px;
}

#worker_list_modal #footer {
    padding: 20px 20px;
    background-color: #eee;
}

#worker_list_modal .ui.form {
    padding: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/WorkerModal_List.vue